export default "<tc-generic-list #collaboratorsList id=\"collaborators-list\"></tc-generic-list>";